
import { ModalButtonType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import { ModalButton, ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { DialogType, ModalType, SimpleDialogParams } from '../../interfaces/simple-dialog';

interface Response {
  body: string;
  headers?: Record<string, Value>;
  status?: number;
  statusText?: string;
}
export class SimpleDialog {

  private static buttonsActionDialog( simpleDialogParams: SimpleDialogParams ):  ModalButton[] {

    const onClickCancel = simpleDialogParams.onClickCancel ? simpleDialogParams.onClickCancel : undefined;
    const onClickOk = simpleDialogParams.onClickOk ? simpleDialogParams.onClickOk : undefined;

    const actions: ModalButton[] = [];

    if ( onClickCancel ) {

      actions.push({
        action: ()=>{onClickCancel()},
        title: simpleDialogParams.titleOnCancel ? simpleDialogParams.titleOnCancel : '',
        type: ModalButtonType.CANCEL,
      })

    }

    if ( onClickOk ) {

      actions.push({
        action: ()=>{onClickOk()},
        title:simpleDialogParams.titleOnOk,
        type: ModalButtonType.SUCCESS,
      })

    }

    return actions;

  }

  private static buttonsAlertDialog( simpleDialogParams: SimpleDialogParams ):  ModalButton[] {

    const actions = [];

    if ( simpleDialogParams.onClickOk ) {

      const onClickOk = simpleDialogParams.onClickOk;

      actions.push({
        action: ()=>{onClickOk()},
        title:simpleDialogParams.titleOnOk,
        type: ModalButtonType.SUCCESS,
      });

    }

    return actions;

  }

  static openDialog( simpleDialogParams: SimpleDialogParams ): void {

    let buttons: ModalButton[] = [];

    if ( !simpleDialogParams.buttons ) {

      switch ( simpleDialogParams.dialogType ) {

        case DialogType.ACTION : buttons = this.buttonsActionDialog( simpleDialogParams );
          break;

        case DialogType.ALERT : buttons = this.buttonsAlertDialog( simpleDialogParams );
          break;

        default:
          break;

      }

    } else {

      buttons = simpleDialogParams.buttons;

    }

    const dialogModal: ModalProps = {
      closeable: simpleDialogParams.closeable,
      closeByDocument: false,
      closeByEscape: false,
      dialogDescription: simpleDialogParams.fragment ? undefined : simpleDialogParams.descriptionDialog,
      dockButtons: buttons,
      focusOnOpen: false,
      fragment: simpleDialogParams.fragment,
      title: simpleDialogParams.titleDialog,
      uuid: generateUUID(),
    };

    if ( simpleDialogParams.modalType ) {

      switch ( simpleDialogParams.modalType ) {

        case ModalType.DIALOG : ModalService.openDialog( dialogModal );
          break;

        case ModalType.FULL_SCREEN : ModalService.openFullscreen( dialogModal );
          break;

        default:  ModalService.openDefault( dialogModal );
          break;

      }

    }

  }

  static showMessageDialog( title: string, description: string, onClickOk: () => void ): void {

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: onClickOk,
      titleDialog: title,
      titleOnOk: 'OK',
    }

    SimpleDialog.openDialog( dialogParams );

  }

  static showErrorMessage( err: Response | string, onClickOk?: () => void, title?: string ): void {

    const dialogTitle = title && title.length > 0 ? title : 'Erro';
    const onClick = onClickOk ? onClickOk : ()=>{};
    let errorMessage = '';

    const error = err as Response;

    if ( error.status === 500 && error.statusText ) {

      errorMessage = error.statusText;

    } else if ( error.body && error.body.length > 0 ) {

      errorMessage = error.body.replace( /[#@#@]/g, '' );

    } else {

      if ( error.status ) {
        errorMessage = error.status.toString();
      }

      if ( error.statusText ) {

        if ( errorMessage.length > 0 ) {

          errorMessage = `${errorMessage} - ${error.statusText}`

        } else {

          errorMessage = error.statusText;

        }

      } else {

        errorMessage = err.toString() ;

      }

    }

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: errorMessage,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: onClick,
      titleDialog: dialogTitle,
      titleOnOk: 'OK',
    }

    SimpleDialog.openDialog( dialogParams );

  }

  static showWarningMessage( warningMessage: string, onClickOk?: () => void, title?: string ): void {

    const dialogTitle = title && title.length > 0 ? title : 'Aviso';
    const onClick = onClickOk ? onClickOk : ()=>{};

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: warningMessage,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: onClick,
      titleDialog: dialogTitle,
      titleOnOk: 'OK',
    }

    SimpleDialog.openDialog( dialogParams );

  }

}